import {
  BstlArtikel,
  AbholzeitType,
  Terminart,
  BPArtikelHinzufuegenRequest,
  PlisteProduktZeit,
  PlisteProduktZeit_PreislisteProdukt as PreislisteProdukt,
  PlisteProduktZeit_PreislisteKategorie as PreislisteKategorie,
  RemoteResult,
  PreislisteZeitraumRequest,
  LoadState,
} from "mangdto"
import router from "@/router"
import { ConverterUtil } from "mangutil"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import moment from "moment"
import BaseLogic from "./base_logic"
import vuexStore from "@/store"

export default abstract class ProdukteLogic extends BaseLogic {
  id: any
  preisliste: PlisteProduktZeit = null
  artikel: PreislisteProdukt = null
  artikelDialogVisible: boolean = false
  created = false
  selectedKategorie: PreislisteKategorie
  createdListener: () => void
  listeLoadState: LoadState = LoadState.Idle
  insertArtikelLoadState: LoadState = LoadState.Idle

  get hasMindestbestellwert(): boolean {
    return false
  }

  get mindestbestellwert(): number {
    return 0
  }

  get kostenlosAb(): number {
    return 0
  }

  init() {
    this.listeLoadState = LoadState.Loading

    var bestellungPending = this.mainLogic.bestellungPending
    var terminart = bestellungPending.terminart
    var datum = null

    if (terminart == Terminart.Abholung) {
      if (bestellungPending.abholung.abholzeitType == AbholzeitType.Baldest) {
        datum = moment().format("yyyy-MM-DDTHH:mm:ss")
      } else {
        var u = bestellungPending.abholung.gewaehlteUhrzeit
        datum = u
      }
    } else if (terminart == Terminart.Sofortbestellung) {
      datum = moment().format("yyyy-MM-DDTHH:mm:ss")
    } else if (terminart == Terminart.Reservierung) {
      datum = bestellungPending.reservierung.zeitVon
    } else if (terminart == Terminart.Lieferung) {
      if (bestellungPending.lieferung.abholzeitType == AbholzeitType.Baldest) {
        datum = moment().format("yyyy-MM-DDTHH:mm:ss")
      } else {
        datum = bestellungPending.lieferung.gewaehlteUhrzeit
      }
    }

    var request = new PreislisteZeitraumRequest()
    request.filialeId = this.filiale.filialeId
    request.zeitpunkt = datum

    Poster.postUser<RemoteResult<PlisteProduktZeit>>(
      RestPaths.artikelPdukteNachZeitSingle,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.listeLoadState = LoadState.Completed

          this.preisliste = response.data.payload
          this.created = true
          if (this.createdListener) {
            this.createdListener()
          }
        } else {
          this.listeLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.listeLoadState = LoadState.Error
      })
  }

  artikelWaehlen(produkt: PreislisteProdukt): void {
    this.artikel = produkt
    this.artikelDialogVisible = true
  }

  bestellungEinfuegen(): void {
    var terminart = this.mainLogic.bestellungPending.terminart
    if (terminart == Terminart.Lieferung) {
      router.push({ name: RouteNames.NEU.WARENKORB_LIEFERUNG })
    } else {
      router.push({ name: RouteNames.NEU.WARENKORB })
    }
    return
  }

  addArtikel(artikel: BstlArtikel) {
    this.insertArtikelLoadState = LoadState.Loading

    var request = new BPArtikelHinzufuegenRequest()
    request.id = vuexStore.state.user.identifier
    request.artikelData = ConverterUtil.convertBstlArtikel(artikel)

    Poster.postUser<RemoteResult<BstlArtikel>>(
      RestPaths.bestellungpendingArtikelHinzufuegen,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.insertArtikelLoadState = LoadState.Completed
          var newArtikel = response.data.payload
          this.mainLogic.bestellungPending.artikelliste.push(newArtikel)
          this.artikel = null
          this.artikelDialogVisible = false
        } else {
          this.insertArtikelLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.insertArtikelLoadState = LoadState.Error
      })
  }

  reloadArtikel(id: string) {
    this.preisliste.kategorien.forEach((kategorie) => {
      kategorie.produkte.forEach((p) => {
        if (p.id == id) {
          this.artikel = p
          return
        }
      })
    })
  }

  highlightCategory(id: any) {}
}
